import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, from, filter } from 'rxjs';

import { coreSelectors } from 'app/core/state';
import { AppState } from 'app/types';
import { notNil } from 'app/utils/stream-util';
import Survey from 'entity/Survey';
import SurveyAnswer from 'entity/SurveyAnswer';
import SurveyQuestion from 'entity/SurveyQuestion';
import SurveyController from 'rest/SurveyController';

@Injectable({
  providedIn: 'root',
})
export class AnswerService {
  private questions: SurveyQuestion[] = [];
  private survey?: Survey;
  private answers: Record<number, SurveyAnswer> = {};
  private userId?: string;
  private referenceId?: string;

  public constructor(store: Store<AppState>) {
    store
      .select(coreSelectors.getUserEntity)
      .pipe(filter(notNil))
      .subscribe(({ userId }) => (this.userId = userId));
  }

  public setId(id: string): void {
    this.referenceId = id;
  }

  public setSurvey(survey: Survey): void {
    this.survey = survey;
    this.questions = survey.questions ?? [];

    if (!this.questions) {
      return;
    }

    this.splitQuestionList();
  }

  public trackAnswer(a: SurveyAnswer): void {
    a.referenceId = this.referenceId;
    if (this.survey?.surveyId === 1) {
      a.referenceType = 'Social';
    }
    a.userId = this.userId;
    if (a.surveyQuestionId) {
      this.answers[a.surveyQuestionId] = a;
    }
  }

  public clearAnswers(): void {
    this.answers = {};
  }

  public getAnswers(): Record<number, SurveyAnswer> {
    return this.answers;
  }

  public splitQuestionList(): SurveyQuestion[][] {
    const newList = [];
    const length = this.questions.length;
    if (length === 0) {
      return [];
    }

    if (length % 2 === 0) {
      //Even
      let i, j, temparray;
      const chunk = 2;
      for (i = 0, j = this.questions.length; i < j; i += chunk) {
        temparray = this.questions.slice(i, i + chunk);
        newList.push(temparray);
      }
    } else {
      //Odd - remove last question to be on it's own.
      const lastQuestion = this.questions.pop();
      let i, j, temparray;
      const chunk = 2;
      for (i = 0, j = this.questions.length; i < j; i += chunk) {
        temparray = this.questions.slice(i, i + chunk);
        newList.push(temparray);
      }
      if (lastQuestion) {
        newList.push([lastQuestion, {}]);
      }
    }

    return newList;
  }

  public submitAnswer(answer: SurveyAnswer): Observable<void> {
    return from(new SurveyController().submitAnswer(answer));
  }
}
